/**
 * The external dependencies.
 */
import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {compose,} from 'ramda';
import moment from 'moment';
import * as R from 'ramda';
import ModalImage from "react-modal-image";
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../components/general/flex-root';
import Header from '../../components/task/shop/header';
import {getAuthUser} from '../../store/auth/selectors';
import {errorDeselect} from '../../store/quality/actions';
import {getCurrentError, getCurrentErrorDetails, getErrorTracking} from '../../store/quality/selectors';
import {getCurrentInstructions, getTaskSteps} from "../../store/tasks/selectors";
import {noworkplace} from "../../store/auth/selectors";
import {getStepNameCombi, getWorkstepLabel, getWorkstepName} from "../../common/utilities";

const BASERURL = process.env.API_URL;
const Wrapper = styled(FlexRootWrapper)`background: #f8f8f8; flex-direction: row;`;
const Row = styled.span`padding-bottom: 10px; border-bottom: 5px solid #d9d7d7;`;
const ContentWrapper = styled(FlexRootWrapper)`
    border-right: 1px solid #d9d7d7;
     > span {
        background: #f8f8f8; 
        font-size: 14px;
        color: #707078;
        padding: 20px 10px;
        > span {
            display: flex;
            margin: 10px;
            min-width: 20%;
            justify-content: space-between;
            > span {
                color: #000;
                margin-left: 10px;
                text-align: right;
            }
        }
        > span + span {
            letter-spacing: -0.03em;
            padding-top: 14px;
            border-top: 1px solid #95989a;
        }
	}
`;

const getEntityId = (val) => {
    return !R.isNil(val) && val !== undefined ? val.id : '';
};

class Form extends React.Component {
    constructor(props) {
        super(props);
    }

    matchStatus(status) {
        switch (status) {
            case 'in-progress':
                return 'in Arbeit';
            case 'in-stock':
                return 'im Vorrat';
            default:
                return status;
        }
    }

    submit = () => {
        const {errorDeselect} = this.props;
        errorDeselect();
    };


    getStepName = (step) => {
        const {workSteps} = this.props;
        let name = getStepNameCombi(workSteps, step);
        return name !== '' ? name : step;
    };

    render() {
        const {current, errorTracking, errorDetails, currentInstructions, noworkplace} = this.props;
        return (
            <Wrapper>
                <ContentWrapper>
                    <Header color='#d9d7d7' textColor="#707070;">Details zum Task</Header>
                    <Row>
                        <span>Fehlermeldung:<span>{current.error_message}</span></span>
                        <span>Mitarbeiter:<span>{current.worker}</span></span>
                        <span>Arbeitschritt:<span>{current.error_step}</span></span>
                        <span>Status:<span>{this.matchStatus(current.status)}</span></span>
                        {!noworkplace && <span>Arbeitsplatz:<span>{current.place}</span></span>}
                    </Row>

                    {errorDetails && errorDetails.instructionEntityList &&
                    errorDetails.instructionEntityList.map((instruction, id) =>
                    <Row>
                            <span>Anleitungsbild {id + 1}:</span>

                            <ModalImage
                                small={BASERURL + '/download/stream/' + getEntityId(instruction.resourcesEntity)}
                                large={BASERURL + '/download/stream/' + getEntityId(instruction.resourcesEntity)}
                                alt=""
                            />
                        </Row>
                    )}

                    {errorDetails && errorDetails.errorreportEntity &&
                    errorDetails.errorreportEntity.resourcesEntity &&
                    <Row>
                        <span>Fehlerbild 1:</span>
                        <ModalImage
                            small={BASERURL + '/download/stream/' + getEntityId(errorDetails.errorreportEntity.resourcesEntity)}
                            large={BASERURL + '/download/stream/' + getEntityId(errorDetails.errorreportEntity.resourcesEntity)}
                            alt=""
                        />
                    </Row>}

                    {errorDetails && errorDetails.errorreportEntity &&
                    errorDetails.errorreportEntity.picture_2 &&
                    <Row>
                        <span>Fehlerbild 2:</span>
                        <ModalImage
                            small={BASERURL + '/download/stream/' + getEntityId(errorDetails.errorreportEntity.picture_2)}
                            large={BASERURL + '/download/stream/' + getEntityId(errorDetails.errorreportEntity.picture_2)}
                            alt=""
                        />
                    </Row>}

                    {errorDetails && errorDetails.errorreportEntity &&
                    errorDetails.errorreportEntity.picture_3 &&
                    <Row>
                        <span>Fehlerbild 3:</span>
                        <ModalImage
                            small={BASERURL + '/download/stream/' + getEntityId(errorDetails.errorreportEntity.picture_3)}
                            large={BASERURL + '/download/stream/' + getEntityId(errorDetails.errorreportEntity.picture_3)}
                            alt=""
                        />
                    </Row>}
                </ContentWrapper>

                <ContentWrapper>
                    <Header color='#d9d7d7' textColor="#707070;">Mögliche Fehlerquellen</Header>
                    {errorTracking && errorTracking.map((task, id) =>
                        <Row key={id}>
                            <span># {id + 1}</span>
                            <span>Mitarbeiter:<span>{task.worker}</span></span>
                            <span>Beginn:<span>{moment(task.open).format('LLLL')}</span></span>
                            <span>Ende:<span>{task.close ? moment(task.close).format('LLLL') : 'nicht beendet'}</span></span>
                            <span>Arbeitszeit:<span>{task.open && task.close ? moment.duration(moment(task.close).diff(moment(task.open), 'minutes'), 'minutes').asMinutes() + ' Minuten' : ''}</span></span>
                            <span>Bearbeitet:<span>{task.close ? moment.duration(moment(task.close).diff(moment(), 'minutes'), 'minutes').humanize(true) : ''}</span></span>
                            <span>Arbeitschritt:<span>{this.getStepName(task.step)}</span></span>
                            <span>Status:<span>{this.matchStatus(task.status)}</span></span>
                            {!noworkplace && <span>Arbeitsplatz:<span>{task.place}</span></span>}
                        </Row>
                    )}
                </ContentWrapper>
            </Wrapper>
        );
    }
}

export default compose(
    connect(
        (state) => ({
            user: getAuthUser(state),
            errorDetails: getCurrentErrorDetails(state),
            errorTracking: getErrorTracking(state),
            current: getCurrentError(state),
            currentInstructions: getCurrentInstructions(state),
            noworkplace: noworkplace(state),
            workSteps: getTaskSteps(state),
        }), {errorDeselect}
    ),
    withRouter
)(Form);



// WEBPACK FOOTER //
// ./src/containers/error-tracking/form.js